import React, { useEffect, useState } from 'react';
import { Popover } from '@headlessui/react';
import clsx from 'clsx';
import config from '../../config';
import BioLibIcon from '../../assets/logos/biolib-icon.png';
import NavbarLink from '@components/atoms/NavbarLink';
import NavbarSearchBar from '@components/atoms/NavbarSearchBar';
import NavbarMobileMenu from '@components/molecules/NavbarMobileMenu';
import NavbarMobileMenuButton from '@components/molecules/NavbarMobileMenuButton';
import NavbarMenu from '@components/molecules/NavbarMenu';
import { dispatchExperimentsTableRefetch } from '../../features/ResultsTable/ExperimentsTable';
import { useIsSignedIn } from '../../apiHooks/userApi';

interface INavigationItem {
    name: string;
    path: string;
}

const navigation: INavigationItem[] = [
    { name: 'Docs', path: '/docs/' },
    { name: 'Explore', path: '/explore/' },
    { name: 'Results', path: '/results/' },
];

interface IProps {
    location: Location;
}

export default function Navbar(props: IProps) {
    const { location } = props;
    const [isScrolledDown, setIsScrolledDown] = useState(false);
    const isSignedIn = useIsSignedIn();

    useEffect(() => {
        const onScroll = () => setIsScrolledDown(window.scrollY > 10);
        window.addEventListener('scroll', onScroll);
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);

    return (
        <Popover
            as='header'
            className={clsx('bg-gradient-dark fixed top-0 z-30 h-14 w-screen', { 'shadow-md': isScrolledDown })}
        >
            <NavbarMobileMenu />
            <div className='h-full bg-white bg-opacity-10 border-b border-white/10'>
                <div className='h-full relative container flex items-center space-x-3 lg:space-x-9'>
                    <div className='flex-1 flex space-x-4 items-center max-w-fit lg:max-w-sm xl:max-w-md'>
                        <NavbarLink link='/' className='flex-none' useATag={!isSignedIn}>
                            <img
                                alt='Logo'
                                draggable={false}
                                src={config.isEnterprise ? config.enterpriseLogoPath : (BioLibIcon as string)}
                                className={clsx('filter invert', config.isEnterprise ? 'w-10' : 'w-6')}
                            />
                        </NavbarLink>

                        <nav className='hidden md:flex space-x-2'>
                            {navigation.map((item) => (
                                <NavbarLink
                                    key={item.name}
                                    link={item.path}
                                    className={clsx(
                                        location.pathname === item.path ? 'text-cyan-100' : 'text-white',
                                        'rounded-md px-2 py-1.5 text-sm font-medium tracking-wide hover:bg-white/10 hover:text-white hover:no-underline',
                                    )}
                                    onClick={item.path === '/results/' ? dispatchExperimentsTableRefetch : undefined}
                                >
                                    {item.name}
                                </NavbarLink>
                            ))}
                        </nav>
                    </div>
                    <div className='flex-1 '>
                        <div className='lg:max-w-sm xl:max-w-md 2xl:max-w-2xl'>
                            <NavbarSearchBar />
                        </div>
                    </div>
                    <div className='flex-none flex items-center'>
                        <NavbarMenu />
                        <NavbarMobileMenuButton />
                    </div>
                </div>
            </div>
        </Popover>
    );
}
